import { IDetailType } from '../interfaces/IDetailType.interface';

export class DetailType implements IDetailType {
	Id: number;
	Name: string;
    Description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/DetailType.ts